var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect } from 'react';
import { useUpdateMultipleUsersStatusMutation } from '../../../../application/features/users/user-api';
import useTranslate from '../../../../localization/helpers';
var ActivateMultipleUsersDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, selectedUsers = _a.selectedUsers, updatedSwitchState = _a.updatedSwitchState;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useUpdateMultipleUsersStatusMutation(), 2), updateMultipleUsersStatus = _c[0], _d = _c[1], updateUserStatusLoading = _d.isLoading, updateUserStatusSuccess = _d.isSuccess;
    var successMessage = useCallback(function () {
        enqueueSnackbar(tWithField('toolTips.activateSuccess', 'common.users'), {
            autoHideDuration: 3000,
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'top' }
        });
        updatedSwitchState(true);
        onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose]);
    useEffect(function () {
        if (updateUserStatusSuccess)
            successMessage();
    }, [successMessage, updateUserStatusSuccess]);
    var onSubmit = function () {
        updateMultipleUsersStatus({ isActive: true, users: selectedUsers });
    };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.activateFunction', 'common.user') }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: 'confirm-dialog-description', children: translate('users.multipleStatusConfirmText', {
                        field: translate('common.activate'),
                        count: selectedUsers.length
                    }) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateUserStatusLoading, variant: 'outlined', color: 'inherit', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateUserStatusLoading, onClick: onSubmit, variant: 'contained', color: 'warning', children: translate('actions.confirm') })] })] }));
};
export default ActivateMultipleUsersDialog;
